// extracted by mini-css-extract-plugin
export default {"sidebar":"styles_sidebar__Z9AJK","icon":"styles_icon__GfEG2","awesomeButton":"styles_awesomeButton__D8eZC"};